// extracted by mini-css-extract-plugin
export default {"table":"DocumentsTable_table__0yON9","buttons":"DocumentsTable_buttons__4+0gc"};